import { createFileRoute } from '@tanstack/react-router';
import { buildNotFoundHead } from '../utils/seo';

export const Route = createFileRoute('/_layout')({
  head: ({ match }) => (match.status === 'notFound' ? buildNotFoundHead() : {}),
});
